
import sys from '@/common/js/sys'
import InformationRouter from './router/InformationRouter.js'
import CommentPlugin from './router/CommentPluginRouter.js'
export default [...InformationRouter,...CommentPlugin];



// WEBPACK FOOTER //
// ./src/content/common/csys/CsysRouter.js